import { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { useWindowDimensions } from 'react-native';
const useFixedHeader = (options = {}) => {
    const { offSet = 80 } = options;
    const windowWidth = useWindowDimensions().width;
    const containerRef = useRef(null);
    const resizeTimeoutRef = useRef();
    const [size, setSize] = useState(null);
    // Memoize the container query to avoid repeated DOM lookups
    const getContainer = useCallback(() => {
        if (!containerRef.current) {
            containerRef.current = document.querySelector('[data-testid="navigation-menu"]');
        }
        return containerRef.current;
    }, []);
    useEffect(() => {
        const container = getContainer();
        if (!container)
            return;
        const handleResize = (entries) => {
            const [entry] = entries;
            const { width, height } = entry.contentRect;
            // Debounce resize events to avoid excessive updates
            if (resizeTimeoutRef.current) {
                clearTimeout(resizeTimeoutRef.current);
            }
            resizeTimeoutRef.current = setTimeout(() => {
                setSize(prevSize => {
                    // Only update if size actually changed
                    if (prevSize?.w === width && prevSize?.h === height) {
                        return prevSize;
                    }
                    return { w: width, h: height };
                });
            }, 16); // ~60fps debouncing
        };
        const ro = new ResizeObserver(handleResize);
        ro.observe(container);
        return () => {
            ro.disconnect();
            if (resizeTimeoutRef.current) {
                clearTimeout(resizeTimeoutRef.current);
            }
        };
    }, [getContainer]);
    // Memoize the calculation to avoid recalculating on every render
    const calculatedWidth = useMemo(() => {
        return windowWidth - offSet - (size?.w ?? 0);
    }, [windowWidth, offSet, size?.w]);
    return calculatedWidth;
};
export default useFixedHeader;
//# sourceMappingURL=useFixedLayout.js.map